import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, references } from '@apexdesigner/schema-tools';

export const pendingStateUpdate = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    triggerId: z
      .string()
      .nullable()
      .optional()
      .hidden()
      .describe('The task, timer, or message that triggered this update'),

    timestamp: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When this update was queued'),

    processInstanceId: z
      .uuid()
      .hidden()
      .describe('Foreign key to ProcessInstance'),

    tenantId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Tenant'),

    processInstance: belongsTo('ProcessInstance'),

    tenant: references('Tenant'),
  })
  .describe('A queued request to advance the process state')
  .as('PendingStateUpdate');

export { pendingStateUpdate as pendingStateUpdateSchema };
